import {
  Autocomplete,
  Box,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { Apartment } from "@mui/icons-material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import { TextField } from "./style";
import { useEffect, useState } from "react";
import { getUniqueValues } from "cerulean-bi-react";
import { useHotelIdStore } from "../../../../utils/hotelIdStore";

/**
 * Navigation bar hotel dropdown common component that uses
 * across modules for display hotels dropdown and select hotels
 */
const NavbarHotelDropdown = () => {
  const [hotelList, setHotelList] = useState([]);
  const setHotelId = useHotelIdStore((state) => state.setHotelId);

  useEffect(() => {
    (async () => {
      const response = await getUniqueValues({
        table: "dim_hotels",
        column: "HotelID",
      });
      if (Array.isArray(response) && response.length > 0) {
        setHotelList(response);
      }
    })();
  }, []);

  return (
    <Grid
      container
      flexDirection="row"
      alignItems="center"
      wrap="nowrap"
      width={250}
      mr={15}
    >
      <Grid
        item
        container
        justifyContent="flex-end"
        alignItems="center"
        flexDirection="column"
      >
        <Autocomplete
          id="primary-hotel-dropdown"
          size="small"
          sx={{
            minWidth: { md: 200, lg: 350 },
            mt: 3,
            mb: -1,
            "& .MuiOutlinedInput-root": {
              color: "#e5e5e5",
            },
            "& .MuiSvgIcon-root": {
              color: "#e5e5e5",
              width: "2rem",
              height: "2rem",
              top: 0,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiAutocomplete-input": {
              fontSize: { md: 13, lg: 15 },
              fontWeight: "bold",
            },
            "& .MuiAutocomplete-endAdornment": {
              top: "calc(50%)",
            },
          }}
          options={hotelList ?? []}
          getOptionLabel={(option) => (option ? option : "")}
          groupBy={(option) =>
            // eslint-disable-next-line no-nested-ternary
            option.group === 1 ? "Favorites" : "Dim Hotels"
          }
          renderOption={(props, option) => (
            <Grid
              id={`hotel-id-${option?.id}`}
              key={`${option?.id}-${option?.isPredefined}`}
              container
              justifyContent="space-between"
              direction="row"
            >
              <Grid item xs={11}>
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {option}
                  <IconButton>
                    <Tooltip title="Hotel Set">
                      <Apartment />
                    </Tooltip>
                  </IconButton>
                </Box>
              </Grid>
              <Grid item xs={1}>
                {!option.isPredefined && (
                  <IconButton
                    key={`${option?.id}-${option?.isPredefined}-icon`}
                    onClick={(e) => null}
                  >
                    <Tooltip
                      title={
                        option.isFavorite
                          ? "Remove from favorites"
                          : "Add to favorites"
                      }
                    >
                      {option.isFavorite ? (
                        <StarIcon sx={{ height: 16, width: 16 }} />
                      ) : (
                        <StarBorderIcon sx={{ height: 16, width: 16 }} />
                      )}
                    </Tooltip>
                  </IconButton>
                )}
              </Grid>
            </Grid>
          )}
          renderGroup={(params) => {
            const sortedGroups = ["Favorites", "Dim Hotels"].map(
              (groupName) => {
                if (
                  params.group === groupName &&
                  params?.children?.length > 0
                ) {
                  return (
                    <Grid key={`Groups-${params.group}`}>
                      <Grid key="Favorites">
                        {groupName === "Favorites" &&
                          params?.children?.length > 0 && (
                            <>
                              {params.children}
                              <br />
                              <Divider
                                sx={{ bgcolor: "#61616173" }}
                                variant="middle"
                              />
                              <br />
                            </>
                          )}
                      </Grid>
                      <Grid key="DimHotels">
                        {groupName === "Dim Hotels" &&
                          params?.children?.length > 0 && (
                            <>
                              <Typography paddingLeft={2} variant="subtitle2">
                                Dim Hotel Sets
                              </Typography>
                              {params.children}
                            </>
                          )}
                      </Grid>
                    </Grid>
                  );
                }
                return null;
              }
            );

            // Filter out null values and render sorted groups
            return sortedGroups.filter((group) => group !== null);
          }}
          isOptionEqualToValue={(option, value) => option === value}
          onChange={(event, value) => {
            setHotelId(value);
          }}
          disableClearable
          value={[]}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              onChange={(e) => {
                if (e.target.value === "") {
                  setHotelId("");
                }
              }}
              color="primary"
              placeholder="Select Hotel"
            />
          )}
          componentsProps={{
            paper: {
              sx: {
                minWidth: 350,
                "& .MuiAutocomplete-listbox": { overflowX: "hidden" },
              },
            },
          }}
        />
      </Grid>
    </Grid>
  );
};
//
export default NavbarHotelDropdown;
